<template>
  <el-container style="width: 100%">
    <el-header>
      <el-button round @click="createClick">{{generateCustomizeString('add')}}</el-button>
      <el-button round @click="freshClick">{{generateCustomizeString('refresh')}}</el-button>
    </el-header>

    <el-table
      :data="templateData"
      tooltip-effect="dark"
      style="width: 96%; margin: 20px auto;"
      v-loading.body="templateListLoading"
    >
      <el-table-column prop="name" :label="generateCustomizeString('templateName')"></el-table-column>
      <el-table-column
        prop="min_package_weight"
        :label="generateCustomizeString('minPackageWeight')"
      ></el-table-column>
      <el-table-column prop="fee_per_quantity" :label="generateCustomizeString('feePerQuantity')"></el-table-column>
      <el-table-column fixed="right" :label="generateCustomizeString('operate')" width="180">
        <template slot-scope="scope">
          <el-button
            @click="editClick(scope.row)"
            type="text"
            size="small"
          >{{generateCustomizeString('edit')}}</el-button>
          <el-button
            type="text"
            size="small"
            @click="deleteClick(scope.row)"
          >{{generateCustomizeString('delete')}}</el-button>
          <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
            <span>{{ generateCustomizeString('confirmDelete') }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">{{ generateCustomizeString('cancel') }}</el-button>
              <el-button type="primary" @click="deleteTemplate()">{{ generateCustomizeString('confirm') }}</el-button>
            </span>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="total, prev, pager, next"
        :total="currentTotal"
      ></el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
// import Paginator from '@/utils/paginator'

export default {
  name: 'Brand',
  data() {
    return {
      currentPage: 1,
      currentTotal: 0,
      templateData: [],
      selectDeleteId: 0,
      dialogVisible: false,
      templateListLoading: false
      // paginator: new Paginator()
    }
  },
  methods: {
    generateCustomizeString,
    editClick(row) {
      this.$router.push({
        name: 'EditTemplate',
        params: { templateId: row.id }
      })
    },
    createClick() {
      this.$router.push({ name: 'CreateTemplate' })
    },
    deleteClick(row) {
      this.selectDeleteId = row.id
      this.dialogVisible = true
    },
    freshClick() {
      this.fetchData(this.currentPage)
    },
    handleCurrentChange(val) {
      this.fetchData(val)
    },
    fetchData(page) {
      if (this.templateListLoading) return
      this.templateListLoading = true

      request({
        url: '/express/template/list',
        method: 'get',
        params: {
          page: page
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          this.templateData = data
          for (var i = 0; i < this.templateData.length; i++) {
            this.templateData[i].fee_per_quantity =
              'NZD $' +
              parseFloat(this.templateData[i].fee_per_quantity / 100).toFixed(2)
          }
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.templateListLoading = false
        })
    },
    deleteTemplate() {
      if (this.selectDeleteId === 0) return

      request({
        url: `express/template/${this.selectDeleteId}`,
        method: 'delete'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('deletedSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('deleteFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('deleteFailed'))
        })
        .finally(() => {
          this.fetchData(this.currentPage)
          this.dialogVisible = false
          this.selectDeleteId = 0
        })
    }
  },
  created: function() {
    this.fetchData(1)
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    }
  },
  watch: {
    viewActived: function(newValue) {
      this.freshClick()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #efefef;
  // color: #333;
  text-align: left;
  line-height: 60px;
}
</style>
